import history from '../history';
const jmfe = window.jmfe || {jsagentInit() {}, jsagentReport() {}, profilerInit() {}, profilerModuleReport() {}};
let jdProfiler = {}
try {
  jdProfiler = Object.keys(jmfe)
    .filter(key => key.indexOf('profiler') === 0)
    .reduce((total, key) => {
      let _key = key.replace('profiler', '')
      _key = _key[0].toLowerCase() + _key.slice(1)
      total[_key] = jmfe[key].bind(jmfe)
      return total;
    }, {})
} catch (ex) {
  console.error(ex)
}

// 生产环境添加烛龙监控
// 数据查看端：http://dra.jd.com/
// 工具库：http://npm.m.jd.com/package/@jmfe/jd-profiler
const flags = [
  ['production', 165],
  ['beta', 195],
];

flags.some(([curEnv, flag]) => {
  if (process.env.API_ENV !== curEnv) return false;
  const options = {
    flag, // 营销中心flag: 165
    autoReport: true,
  };

  try {
    jmfe.profilerInit(options);
    jmfe.jsagentInit(options);
  } catch (ex) {
    console.error('烛龙平台埋点报错', ex);
  }

  return true;
});

window.ACORE = window.ACORE || {};

// perfomance.now()
// [页面总时间, 最后一次页面pv时间]
let redirectTime = [0, 0];

function computedTotalPageStayTime() {
  [redirectTime[0], redirectTime[1]] = [redirectTime[0] + (performance.now() - redirectTime[1]), performance.now()];
}

function initperflog() {
  // 如果初始化过就跳过
  if (redirectTime[1] !== 0) return;

  redirectTime = [0, performance.now()];
  let prevHref = window.location.href;

  history.listen(function () {
    if (prevHref === window.location.href) return;
    computedTotalPageStayTime();
    prevHref = window.location.href;
  });
}

function logperf(pits, config) {
  const innerPits = (Array.isArray(pits) ? pits : [pits]).map((item) => {
    return {
      ...item,
      time: Math.floor(getperfnow(item.time)),
    };
  });

  try {
    jmfe.profilerModuleReport(innerPits, config);
  } catch (ex) {
    console.error(ex);
  }
}

// 计算方法调用到页面加载所花费的时间，其组成部分为主接口加载时间 + 页面进入时间到方法调用时间
function getperfnow(time) {
  if (time == null) return performance.now() - redirectTime[0];
  return time;
}

// 固定当前时间之后的性能指标按照该值计算
function fixperfnow() {
  const stashedRedirectTime = redirectTime.slice();

  return function getperfnow(time) {
    if (time == null) return performance.now() - stashedRedirectTime[0];
    return time;
  };
}

function loginit() {
  // yxinit
  logperf({ key: 'yxinit', desc: 'yxinit', number: 13 });
}

function cacheHitLog() {
  //缓存命中时上报
  logperf({ key: 'yxmainapihit', desc: 'yxmainapihit', number: 8, time: performance.now() });
  initperflog();
}

function logmainapi() {
  // 主接口请求完成
  logperf({ key: 'yxmainapi', desc: 'yxmainapi', number: 10, time: performance.now() });

  initperflog();
}

function logindexpage() {
  // 首页已进入
  logperf({ key: 'yxmindexpage', desc: 'yxmindexpage', number: 11 });
}

function logsingup() {
  // 收品活动报名
  logperf({ key: 'yxsignup', desc: 'yxsignup', number: 12 });
}

function logroomlist() {
  // 收品活动报名
  logperf({ key: 'yxroomlist', desc: 'yxroomlist', number: 14 });
}

loginit();

window.ACORE.getperfnow = getperfnow;

window.ACORE.getperfInnerData = function () {
  return redirectTime;
};

window.ACORE.jdProfiler = jdProfiler;

window.ACORE.logperf = logperf;

window.ACORE.fixperfnow = fixperfnow;

function selfJsagentReport(errMsg, extra, config = {}) {
  const { errLevel = 4, errType = 2, errCode = 1012 } = config;
  const _extra = extra == null ? extra : typeof extra === 'string' ? { msg: extra } : extra;
  _extra.__userId = window.__global_user_id;
  _extra.__href = window.location.href;
  _extra.__plat = 'activity-core';
  try {
    jmfe.jsagentReport(errType, errCode, errMsg, _extra, errLevel);
  } catch (ex) {
    console.error(ex);
  }
}

export {
  logperf,
  loginit,
  logmainapi,
  logindexpage,
  logsingup,
  logroomlist,
  fixperfnow,
  cacheHitLog,
  selfJsagentReport,
};

// -----------------test----------------
// --[0, 500]--------[0, 500]------------[200, 700]--------------[200, 700]--------->
// --init:500ms-------point:560ms(560)---routechange:700ms------pint:780(580)------->

function startTest() {
  let startTimeOfTest = window.performance.now();

  console.log('teststart------------------------------------------------');

  function getDistance(time) {
    return performance.now() - startTimeOfTest - time;
  }

  function dely(time) {
    let resolve;

    let prom = new Promise((res) => {
      resolve = res;
    });

    setTimeout(() => {
      resolve();
    }, time);

    return prom;
  }

  (async () => {
    await dely(500);
    // [0, 500]
    logmainapi();

    console.log('主接口请求完成', redirectTime, [0, startTimeOfTest + 500], '偏移:' + getDistance(500));

    await dely(200);

    // [200, 700]
    computedTotalPageStayTime();

    console.log('首次页面跳转在700ms后', 200, redirectTime, startTimeOfTest + 500 + 200, '偏差：' + getDistance(700));
    console.log(
      '首次页面跳转在700ms后立即上报的埋点是',
      500,
      getperfnow() - startTimeOfTest,
      '偏差:' + getDistance(700)
    );

    await dely(80);

    // let now = performance.now()
    // console.log('首次页面跳转在780ms后立即上报的埋点是', getDistance(580), redirectTime[0], '偏差:' + getDistance(780))

    await dely(100);
    // 100ms 后跳转
    // [380, 880]
    computedTotalPageStayTime();

    await dely(100);
    // 在100ms后跳转
    // [480, 980]
    computedTotalPageStayTime();

    await dely(80);
    console.log(
      '首次页面跳转在700ms后立即上报的埋点是',
      580,
      getperfnow() - startTimeOfTest,
      '偏差:' + getDistance(1060)
    );

    // ---------bug测试
    setTimeout(() => {
      // 但是实际值应该少了80ms 减少的是当前页面的停留时长
      console.log('实际值应该偏差了180ms', 780, getperfnow() - startTimeOfTest, '偏差:' + getDistance(1260));
      // 延时100ms上报
    }, 200);

    const innerGetperfnow = fixperfnow();
    setTimeout(() => {
      console.log(
        '首次页面跳转在700ms后立即上报的埋点是',
        780,
        innerGetperfnow() - startTimeOfTest,
        '偏差:' + getDistance(1260)
      );
      // 延时100ms上报
    }, 200);

    // 在100ms后跳转
    await dely(100);
    // [680, 1160]
    computedTotalPageStayTime();
    // ---------bug测试

    await dely(200);
    console.log('实际值应该偏差了180ms', 700, getperfnow() - startTimeOfTest, '偏差:' + getDistance(1160));
  })();

  console.log('teststart------------------------------------------------');
}

// window.startTest = startTest;
